/* eslint-disable react-hooks/exhaustive-deps */
import { Badge } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useTerminationRequestCount } from '../../../contexts/termination-request-count';
import useStore from '../../../store';
import c from '../../../constant';

function IntermediaryTerminationBranchManagerBadgeCount() {
	const { currentUser: user } = useStore((state) => state.currentUser);
	const { loadCountTerminationBranchManager: load, countTerminationBranchManagerOfficeReview: countOffice } = useTerminationRequestCount();

	useEffect(load, []);

	return (
		<>
			{c.stepOfficeRoles.includes(user?.position) && parseInt(countOffice) > 0 && (
				<>
					<Badge colorScheme="red" variant="solid" ml={1}>
						{parseInt(countOffice)}
					</Badge>
				</>
			)}
		</>
	);
}

export default IntermediaryTerminationBranchManagerBadgeCount;
